import { getCoordToIndex } from "./getCoordToIndex.js";
import { domIdentitiesIterator } from "./iterators.js";
function createIdentityBitmap(identities) {
  const rootElement = {
    identity: identities[0],
    parentIndex: identities[1],
    top: identities[2],
    right: identities[3],
    bottom: identities[4],
    left: identities[5]
  };
  const rootWidth = rootElement.right - rootElement.left;
  const rootHeight = rootElement.bottom - rootElement.top;
  const rootArea = rootWidth * rootHeight;
  const coordToIndex = getCoordToIndex(rootWidth);
  const bitmap = new Uint32Array(rootArea);
  for (const element of domIdentitiesIterator(identities)) {
    const { identity, top, right, bottom, left } = element;
    const elementWidth = right - left;
    const elementHeight = bottom - top;
    for (let i = 0; i <= elementWidth; i++) {
      for (let j = 0; j <= elementHeight; j++) {
        const x = left + i;
        const y = top + j;
        const idx = coordToIndex(x, y);
        if (idx >= 0 && idx < bitmap.length) {
          bitmap[idx] = identity;
        }
      }
    }
  }
  return bitmap;
}
export {
  createIdentityBitmap
};
//# sourceMappingURL=createIdentityBitmap.js.map
